module.exports = __webpack_public_path__ + "img/download.40e9eace.svg";